<template>
  <PageFrame v-if="slides[0]" :embedded="embedded" :theme="slideDeck.themeData" :options="slides[0].options" :direction="direction">
    <div v-if="!modalPreview" class="built-on">
      <n-link to="/">
        <img class="built-logo" src="/swf-logo.svg">
      </n-link>
    </div>

    <div v-if="showOnboarding" class="container deck-container live-demo m-b-100">
      <div class="notification has-text-centered is-primary">
        <h2 class="title is-4 m-t-30"><span class="emoji">✨</span> Like this deck? Copy it into your account to get started</h2>
        <!-- <p class="subtitle is-5" style="max-width: 700px;margin: -.35em auto 1em;">Browse the popular slide deck templates below to find one you like, then duplicate it into your account!</p> -->
        <n-link :to="'/decks?startDeck=' + slideDeckId" class="button is-medium is-primary is-inverted m-b-20">Click here to use this template</n-link>
      </div>
    </div>

    <div class="container m-b-40" data-cy="preview-banner-slider">
      <div class="action-bar">
        <h2 class="title is-2">{{ slideDeck.name }}</h2>
      </div>
      <div class="columns reversed">
        <div class="column is-two-fifths action-column">
          <div class="buttons">
            <!-- launch event or register -->
            <div v-if="loggedIn" @click="openEventModal()" class="button register is-primary is-medium is-special  big-cta" style="flex-grow: 1;"><i class="fas fas fa-chalkboard-teacher m-r-10" data-cy="start-event-button" /> Start a live event</div>
            <div v-else @click="startRegister()" class="button register is-primary is-medium is-special  big-cta" style="flex-grow: 1;"><i class="fas fa-user-plus m-r-10" /> Sign up to use this deck</div>

            <!-- edit deck -->
            <n-link v-if="canEdit" :to="'/edit/' + slideDeckId" class="button is-light-white is-medium big-cta" style="flex-grow: 1;"><i class="fas fa-edit m-r-10" /> Edit this deck</n-link>

            <!-- copy deck -->
            <b-button v-if="canCopy" @click="startDuplicateDeck" class="button is-light-white is-medium big-cta" style="flex-grow: 1;" data-cy="copy-and-customize"><i class="fas fa-edit m-r-10" /> Copy and customize</b-button>
          </div>
          <div class="tag-group">
            <div v-for="tag in meta.tags" :key="tag" class="tag is-outlined">{{ tag }} &nbsp;</div>
          </div>
          <div class="description">
            {{ description }}
          </div>

          <div class="level meta vertical">
            <div class="square is-small">
              <div class="streamline">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><defs><style>.a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}</style></defs><title>image-picture-gallery</title><rect class="a" x="3" y="4" width="10.5" height="8.5" rx="1" transform="translate(16.5 16.5) rotate(180)" /><path class="a" d="M.5,10V2.5a1,1,0,0,1,1-1h9" /><path class="a" d="M3.605,12.419,7.527,8.265a1,1,0,0,1,1.45,0l3.958,4.14" /></svg>
              </div>
              <p>{{ totalSlides }} slides</p>
            </div>
            <div class="square is-small">
              <div class="streamline">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><defs><style>.a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}</style></defs><title>interface-time-clock-circle</title><circle class="a" cx="7" cy="7" r="6.5" /><polyline class="a" points="7 4.5 7 7 9.541 9.965" /></svg>
              </div>
              <p>{{ durationEstimate }}</p>
            </div>
            <div class="square is-small">
              <div class="streamline">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><defs><style>.a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}</style></defs><title>interface-user-multiple</title><circle class="a" cx="5" cy="3.25" r="2.25" /><path class="a" d="M9.5,13H.5V11.5a4.5,4.5,0,0,1,9,0Z" /><path class="a" d="M8.48,1.06A2.284,2.284,0,0,1,9,1,2.25,2.25,0,0,1,9,5.5a2.292,2.292,0,0,1-.48-.051" /><path class="a" d="M9.976,7.106A4.5,4.5,0,0,1,13.5,11.5V13h-2" /></svg>
              </div>
              <p>{{ numPeople || '3-12' }} people</p>
            </div>
            <!-- <div class="square is-small">
              <div class="text-icon">
                {{ meta.rating || 'All' }} Audiences
              </div>
              <p>Suitable for {{ meta.rating || 'All' }} Groups</p>
            </div> -->
          </div>
        </div>

        <div class="column is-three-fifths recap-column">
          <div class="recap-container horizontal">
            <div class="toc-column" />
            <div style="flex-grow: 10">
              <!-- <p class="recap-title">Slide Deck Preview</p> -->
              <div class="slide-preview-container container" data-cy="slide-preview-container">
                <div class="inner-container">
                  <!-- <div class="preview-notice">This is a preview! Host a live event to play</div> -->
                  <div v-if="prevSlideIndex" @click.stop="previousStep()" class="direction prev" data-cy="slide-preview-direction-prev">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                      <defs>
                        <style>
                          .a {
                          fill: none;
                          stroke: #000;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          }
                        </style>
                      </defs>
                      <title>interface-arrows-button-left</title>
                      <path class="a" d="M10.146.5,4,6.646a.5.5,0,0,0,0,.708L10.146,13.5" />
                    </svg>
                  </div>
                  <SlideContainer id="slide-container" v-for="(slide, key) in slides" :active="isActive(key)" :key="slide.id"
                                  :slide="slide" :moderatorView="true" :step="step" :theme="slideDeck.themeData" :event="event"
                                  :recap="true" :metaData="slideDeck.metaData" :data-cy="`preview-slide-id-${key}`"
                  />
                  <div v-if="nextSlideIndex <= slides.length || nextStepNum" @click.stop="nextStep()" class="direction next" data-cy="slide-preview-direction-next">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                      <defs>
                        <style>
                          .a {
                          fill: none;
                          stroke: #000;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          }
                        </style>
                      </defs>
                      <title>interface-arrows-button-right</title>
                      <path class="a" d="M3.854.5,10,6.646a.5.5,0,0,1,0,.708L3.854,13.5" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loggedIn" class="container notification is-primary is-light level" style="margin-bottom: 40px;">
      <p class="m-r-50" style="font-size: 1.25em">This is an interactive slide deck for group meetings, lessons, and events. You can play and customize it by creating an account 👉 </p>
      <n-link :to="'/decks?startDeck=' + $route.params.id" class="button register is-primary is-medium is-special  big-cta">Create a free account</n-link>
    </div>

    <div class="container m-b-50 m-t-10">
      <h3 class="subtitle is-4 slide-overview">Slide Overview</h3>
      <div class="slide-summary" data-cy="preview-slide-summary">
        <div v-for="type in slideSummary" :key="type.name" class="type">
          <span class="icon">{{ type.emoji }}</span>
          {{ type.count }} {{ type.name }}
        </div>
      </div>

      <!-- <h3 class="subtitle is-4 slide-overview m-t-30">Content Preview</h3> -->
      <div v-if="isMounted" class="content-preview m-t-30 m-b-40" data-cy="deck-content-preview">
        <div v-for="slide in previewSlides" :key="slide.id" class="preview" data-cy="deck-content-preview-slide">
          <span class="order">{{ slide.order }}</span>

          <div class="preview-slide-container">
            <SlideContainer
              :preview="true"
              :step="previewSlideSteps[slide.id] || 1"
              :slide="slide"
              :theme="slideDeck.themeData"
              :metaData="slideDeck.metaData"
              :frozenScreenshot="true"
              class="preview-slides"
            />
          </div>

          <div class="content-column">
            <p class="slide-type">{{ slideTitles[slide.template] }}</p>
            <div v-if="slide.content.html" class="text rich-text content">
              <div v-html="slide.content.html" />
            </div>
            <div v-else class="text">
              <p class="maintext">{{ getContent(slide).title }}</p>
              <p class="subtext">{{ getContent(slide).subtitle }}</p>
            </div>
            <div v-if="slide.steps.length > 1" class="active-steps">
              <template v-for="(activeStep, key) in slide.steps">
                <p :key="'active-' + activeStep.name" v-if="activeStep.skip === false" :class="{ 'is-active': previewSlideSteps[slide.id] ? (key + 1) === previewSlideSteps[slide.id] : key === 0 }" @click.stop="setPreviewSlideStep(slide.id, (key + 1))">
                  {{ (key + 1) === step ? '' : '' }}{{ activeStep.name }}
                </p>
              </template>
            </div>
          </div>
        </div>

        <div class="has-text-centered">
          <div v-if="numSlidesVisible < slides.length" @click="numSlidesVisible += 10" class="button is-large m-t-20">Show more slides</div>
        </div>
      </div>

      <!-- <div class="logo-container">
        <n-link to="/">
          <img class="logo" src="/swf-logo-dark.svg">
        </n-link>
      </div> -->
    </div>

    <div v-if="loggedIn" class="container is-shell m-b-50">
      <HelpfulUpgrade />
    </div>

    <div v-if="!loggedIn" class="container is-shell">
      <div class="notification is-primary has-text-centered">
        <!-- <h2 class="title is-2 has-text-centered">Make your events more engaging</h2> -->
        <!-- <h2 class="title is-2 has-text-centered">Make your events more engaging</h2> -->
        <h2 class="title is-2 has-text-centered">Engagement you can prove</h2>
        <template>
          <p>Customize an interactive slide deck like this one and host an event for your friends &mdash; SlidesWith is the easiest way to have more fun remotely and throw events your group will love. Create a free account to start using it:</p>
          <br>
          <div class="form-inputs">
            <b-field type="is-white">
              <b-input v-model="email" placeholder="Enter your email..." type="text" size="is-medium" />
            </b-field>
            <p class="control">
              <button @click="startRegister(); trackEvent('Single Deck Lower CTA')" class="button is-primary is-inverted is-large"><b>Try it free</b></button>
            </p>
          </div>
          <br><br>
        </template>
      </div>
    </div>
    <ExitIntentModal />
    <div @click="$parent.close()" class="new-modal-background" />
  </PageFrame>
</template>
<script>
import { getSingleDeck } from '~/queries/getSingleDeck.gql'

import HelpfulUpgrade from '~/components/HelpfulUpgrade'
import PageFrame from '~/components/PageFrame'
import SlideContainer from '~/components/SlideContainer'
import Slideshow from '~/components/mixins/Slideshow'
import ExitIntentModal from '~/components/modals/ExitIntentModal'
import StartEventModal from '~/components/modals/StartEventModal'
import DeckSettingsModalControls from '~/components/mixins/DeckSettingsModalControls'
import DuplicatesDecks from '~/components/mixins/DuplicatesDecks'

export default {
  auth: false,
  head () {
    return {
      title: this.title,
      link: [
        { hid: 'canonical', rel: 'canonical', href: 'https://slideswith.com' + this.$route.path }
      ]
    }
  },
  components: {
    PageFrame,
    SlideContainer,
    HelpfulUpgrade,
    ExitIntentModal
  },
  mixins: [
    Slideshow, DeckSettingsModalControls, DuplicatesDecks
  ],
  props: {
    embedded: { default: false },
    modalPreview: { default: false },
    deckId: { default: null }
  },
  validate ({ params }) {
    if (!this.modalPreview) {
      return /^\d+$/.test(params.id)
    } else {
      return true
    }
  },
  data () {
    return {
      email: '',
      isLocalPreview: true,
      slideDeck: {},
      event: {},
      loggedIn: false,
      numSlidesVisible: 10,
      isMounted: false,
      slideTitles: {
        joinSlide: 'Join Event',
        ratingSlide: 'Pick a Rating',
        titleSlide: 'Title Slide',
        pollSlide: 'Poll Question',
        imageShare: 'Image Share Slide',
        contentSlide: 'Content Slide',
        multipleChoice: 'Multi-Choice Question',
        userVote: 'Players Vote',
        wordCloud: 'Word Cloud Slide',
        specificTextAnswer: 'Text Answer Question',
        passTheMic: 'Pass the Mic Slide',
        answerSummary: 'Answer Review Slide',
        scoreSummary: 'Leaderboard Slide',
        powerPoint: 'Imported Slide'
      },
      previewSlideSteps: {},
      isPageLoadCaptured: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    isOwner () {
      return this.slideDeck.userId === this.user.id
    },
    teamData () {
      return this.slideDeck.teamData || {}
    },
    canEdit () {
      const canEditTeamDeck = this.user.id && this.teamData?.teamId && // logged in and is team deck
                              this.user.team?.id === this.teamData.teamId && // same team
                              this.user.team?.canEdit !== false && // user has edit privilages
                              this.teamData?.allowEdit !== false // deck is marked editable

      return this.isOwner || canEditTeamDeck
    },
    canCopy () {
      const canCopyTeamDeck = this.user.id && this.teamData.teamId && // logged in and is team deck
                        this.user.team?.id === this.teamData?.teamId && // same team
                        this.teamData?.allowCopy !== false // deck is marked copyable

      return this.isOwner || canCopyTeamDeck || this.slideDeck.isPublic
    },
    slideDeckId () {
      return this.$route.params.id || this.deckId
    },
    slides () {
      if (!this.slideDeck.slides) { return [] }
      // const slides = [...this.slideDeck.slides]
      // slides.shift()
      return this.slideDeck.slides
    },
    previewSlides () {
      return this.slides.slice(0, this.numSlidesVisible)
    },
    shortDeckName () {
      return this.slideDeck.name ? this.slideDeck.name.replace(/Copy of/g, '') : 'Live Event'
    },
    title () {
      return this.slides[0] && this.slides[0].content
        ? this.slides[0].content.title
        : ''
    },
    description () {
      if (this.meta.description && this.meta.description.length > 3) {
        return this.meta.description
      } else {
        return `This is an interactive presentation for ${this.numPeople} to play in an online event. There are ${this.totalSlides} slides that should take about ${this.durationEstimate} to play through. The host can launch an event, players join on their phones via a short url or QR code. See a preview of the slides below!`
      }
    },
    slideSummary () {
      const summary = {}
      const nameMap = {
        joinSlide: 'Join Slide',
        titleSlide: 'Title Slide',
        userVote: 'User Voting Slide',
        multipleChoice: 'Multiple Choice Question',
        specificTextAnswer: 'Text Answer Question',
        passTheMic: 'Pass the Mic Slide',
        ratingSlide: 'Rating Slide',
        imageShare: 'Image Sharing Slide',
        answerSummary: 'Answer Review Slide',
        scoreSummary: 'Leaderboard Slide',
        pollSlide: 'Poll Slide',
        wordCloud: 'Word Cloud',
        contentSlide: 'Rich Content Slide',
        powerPoint: 'Imported Slide'
      }

      const emojiMap = {
        titleSlide: '🔤',
        userVote: '🙋‍♀️',
        multipleChoice: '❓',
        specificTextAnswer: '✍',
        passTheMic: '🎤',
        ratingSlide: '👍',
        imageShare: '📷',
        answerSummary: '✅',
        scoreSummary: '🥇',
        pollSlide: '📊',
        contentSlide: '📝',
        wordCloud: '💭',
        powerPoint: '🎇'
      }

      this.slides.forEach((slide) => {
        const template = slide.template
        if (template === 'joinSlide') { return }
        if (summary[template]) {
          if (summary[template].count === 1) {
            summary[template].name = summary[template].name + 's'
          }
          summary[template].count++
        } else {
          summary[template] = {
            count: 1,
            name: nameMap[template],
            emoji: emojiMap[template]
          }
        }
      })

      return summary
    },
    numPeople () {
      const groups = {
        small: '3-50',
        medium: '50-250',
        large: '250-1000',
        all: '3-1000'
      }
      return groups[this.meta.groupSize] || '3-12'
    },
    questions () {
      const questions = ['multipleChoice', 'specificTextAnswer']
      return this.slides.filter(s => questions.includes(s.template)).length
    },
    meta () {
      return this.slideDeck.metaData || {}
    },
    userSlides () {
      const questions = ['userVote', 'passTheMic', 'imageShare']
      return this.slides.filter(s => questions.includes(s.template)).length
    },
    totalSlides () {
      return this.slides.length
    },
    durationEstimate () {
      const base = 5 * Math.round(this.slides.length / 5)

      let margin = Math.round(base / 25)
      margin = margin * 5

      if (margin === 0) {
        return base + '-' + (base + 5) + ' mins'
      }

      return (base - margin) + '-' + (base + margin) + ' mins'
    },
    showOnboarding () {
      const user = this.$store.state.user
      return this.$auth.loggedIn && user.slideDeckCount < 1
    }
  },
  async mounted () {
    this.log('is logged in? ', this.$auth.loggedIn)
    if (this.$auth.loggedIn) {
      await this.getLoggedInSlideDeck()
    } else {
      await this.getCachedSlideDeck()
    }

    this.mountSlideshow()

    // add keyboard navigation
    if (this.keyboardNavigation) {
      window.addEventListener('keydown', this.handleKeydown)
    }

    this.loggedIn = this.$store.state.auth.loggedIn
    this.isMounted = true
  },
  methods: {
    async getLoggedInSlideDeck () {
      const { data: { slideDecks } } = await this.$apollo.query({
        query: getSingleDeck,
        variables: {
          id: this.slideDeckId
        }
      })
      this.handleSlideDeck(slideDecks?.[0])
    },
    async getCachedSlideDeck () {
      // create new Axios instance and remove Auth headers to get caching with Cloudflare
      const instance = this.$axios.create()
      delete instance.defaults.headers.common

      const endpoint = `https://graphql.slideswith.com/api/rest/slide-deck/${this.slideDeckId}`
      const response = await instance.get(endpoint)
      const data = response.data
      this.log('fetched cached slide deck', data)
      this.handleSlideDeck(data?.slideDecks?.[0])
    },
    handleSlideDeck (deck) {
      this.log('handling slide deck', deck)

      if (!deck) {
        this.$buefy.toast.open({ type: 'is-danger', message: 'No published deck with that code' })
        this.$router.push('/decks')
        return
      }

      const meta = deck.metaData
      const isOwner = deck.userId && deck.userId === this.$auth?.user?.id
      this.log('is owner?', isOwner)

      if (!isOwner && !deck.isPublic && meta.createPublicPage !== true && !deck.teamId) {
        this.$buefy.toast.open({ type: 'is-danger', message: `You don't have access to this deck` })
        this.$router.push('/decks')
        return
      }

      // Avoid duplicate captures
      if (!this.isPageLoadCaptured) {
        this.posthogCapture('deck:preview', { deck_id: deck.id, deck_name: deck.name })
        this.isPageLoadCaptured = true
      }

      this.slideDeck = deck
    },
    setPreviewSlideStep (slideId, step) {
      this.$set(this.previewSlideSteps, slideId, step)
      this.log('setPreviewSlideStep to: ', { slideId, step })
      this.log({ previewSlideSteps: this.previewSlideSteps })
    },
    startRegister () {
      this.$router.push({ path: '/register', query: { email: this.email, startDeck: this.slideDeckId } })
    },
    openEventModal () {
      this.$buefy.modal.open({
        parent: this,
        component: StartEventModal,
        hasModalCard: false,
        trapFocus: true,
        customClass: 'start-event-modal',
        props: {
          slideDeck: this.slideDeck,
          canEditDeck: this.canEdit,
          canEditSettings: false
        }
      })

      const data = {
        from_location: 'preview_page',
        deck_id: this.slideDeck.id,
        deck_name: this.slideDeck.name
      }
      this.posthogCapture('event:launch_modal_open', data)
    },
    getContent (slide) {
      const content = {}

      if (slide.content.title) {
        content.title = slide.content.title
        content.subtitle = slide.content.subtitle
        content.image = slide.content.image
      }

      if (slide.prompts[0] && slide.prompts[0].text) {
        content.title = slide.prompts[0].text
        content.image = slide.prompts[0].image
      }

      if (slide.prompts && slide.prompts.text) {
        content.title = slide.prompts.text
        content.image = slide.prompts.image
      }

      if (slide.prompt && slide.prompt.text) {
        content.title = slide.prompt.text
        content.image = slide.prompt.image
      }

      return content
    },
    startDuplicateDeck () {
      if (!this.$auth.user) {
        return this.$router.push('/decks?startDeck=' + this.slideDeckId)
      }
      this.startDeckSettingsModal(this.slideDeckId, {
        trackingData: {
          domain: 'onboard',
          templateId: this.slideDeck.id,
          templateName: this.slideDeck.name
        }
      }).then(async (data) => {
        if (data) {
          this.posthogCapture('deck:create_from_preview_page', { from_location: 'preview page', from_deck_id: this.slideDeck.id, from_deck_name: this.slideDeck.name })
          await this.duplicateDeck(this.slideDeckId, data, { keepName: !!data.deckName })
          await this.$router.push('/edit/' + this.highlightDeck)
        }
      })
    }
  }
}
</script>
<style lang="scss">
// slide modifications for local preview
.is-slide.is-local {
  .event-details .flex-column {
    text-align: center !important;
    font-size: 1.2em;
    padding: 0 1em;
  }
  .join-box, .join-info {
    display: none;
  }
}

.text.rich-text {
  margin-bottom: 0;

  h1 { font-size: 1.1em; }
  h2 { font-size: 1em; }
  h3 { font-size: .9em; }
}

.streamline {
  width: 1.5em;
  height: 1.5em;
  margin: 0 auto 5px;

  svg {
    width: 100%;
    height: 100%;

    .a {
      stroke: currentColor;
      fill: none;
    }
  }
}

.modal.deck-preview-modal {
  overflow-y: scroll;
  justify-content: flex-start;

  .modal-background {
    background-color: transparent;
    display: none;
  }

  .new-modal-background {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 200vw;
    display: block;
    position: absolute;
    top: 0;
    left: -50vw;
    margin-right: auto;
    text-align: center;
    z-index: -2;
  }

  .modal-content {
    max-width: 1100px;
    max-height: none;
    overflow: visible;

    .page-frame {
      padding-top: 1.5em;
      margin-top: 1.5em;
      margin-bottom:2em;
      border-radius: 4px;
    }
  }
}

body.is-noscroll {
  padding-right: 17px;
  height: auto;
}
</style>

<!-- SCOPED STYLES -->
<style lang="scss" scoped>

.preview-slide-container {
  position: relative;
  height: 340px;
  width: 580px;
  min-width: 580px;
  font-size: .5em;
  margin: 1em;
  border-radius: 6px;
  overflow: hidden;
}

.column.recap-column {
  max-width: 100%;
}

@media screen and (min-width: 769px) {
  .columns.reversed {
    flex-direction: row-reverse;
  }
  .column.recap-column {
    // max-width: 65%;
  }
}
.action-bar {
  display: flex;
  justify-content: space-between;

  .title {
    margin-bottom: .5em;
    // max-width: 500px;
  }
}
.action-column{
  .buttons {
    margin-top: .7em;

    .fas {
      font-size: .9em;
      position: relative;
      top: 1px;
    }

    .button {
      margin-right: 0;
    }
  }
}

.fb-container {
  margin: 1.5em -.75em 0 0;
  padding: 0;
  display: flex;
  gap: .5em;
  flex-wrap: wrap;
}

.fb-average {
  position: absolute;
  top: .8em;
  right: .8em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 1.35em;

  .avg-emoji {
    font-size: 2.25em;
    margin-left: .1em;
  }
}

.player-feedback {
  max-width: 50%;
  min-width: 48%;
  border-radius: 12px;
  background-color: #f5f5f5;
  padding: 1em;

  .player-box {
    float: right;
    margin-left: 1em;
    margin-top: .1em;
    margin-right: 0;
  }

  .fb-avatar {
    width: 1.4em;
    height: 1.4em;
    border-radius: 1em;
    background-color: #f5f5f5;
    padding: .2em;
    margin-bottom: -.35em;
  }

  .fb-name {
    background-color: #999;
    color: #f5f5f5;
    font-weight: bold;
    padding: .2em .6em;
    font-size: .95em;
    // transform: rotate(-4deg);
  }

  .fb-comment {
    padding: .3em 0;
    // border-radius: 10px;
    // background-color: rgba(100,100,100,.05);
    margin-top: .4em;
    font-size: 1.1em;
    font-style: italic;
    position: relative;
  }

  .fb-emoji {
    display: flex;
    font-size: 1.5em;
    text-align: right;
    justify-content: flex-start;

    P {
      opacity: .2;
      filter: saturate(0) contrast(.3);

      &.selected {
        opacity: 1;
        filter: saturate(1) contrast(1);
      }
    }
  }
}

.is-screenshot {
  .slide-preview-container {
    border-radius: 0px;

    .inner-container {
      border-radius: 0px;
    }
  }

  .direction.next,
  .direction.prev {
    display: none;
  }
}

.inline-slide-preview {
  position: relative;
  bottom: 0;
  left: 0;
  width: 700px;
  height: 400px;
  margin: 1em auto 1em 0;
  border-radius: 10px;
  overflow: hidden;
  transform-origin: left center;
}

.preview-notice {
  position: absolute;
  letter-spacing: 1px;
  top: 0;
  left: 0;
  right: 0;
  background-color: var(--contrast);
  width: 100%;
  // font-weight: bold;
  color: var(--fullContrast);
  font-size: .9em;
  height: 2.6em;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.social-share {
  display: flex;
  position: absolute;
  width: 48px;
  top: 10px;
  left: -80px;
  flex-direction: column;

  a {
    // color: var(--text);
    color: #aaa;
    opacity: .6;

    &:hover {
      opacity: .9;
    }
  }
}

.isLight .social-share {
  a {
    color: #666;
  }
}

.how-it-works {
  img {
    mix-blend-mode: multiply;
  }

  img {
    border-radius: 15px;
    // box-shadow: 1px 5px 12px -5px rgb(119, 45, 99);
    margin-bottom: 0px;
    // width: 80%;

    &.play {
      margin-top: 10px;
      margin-bottom: -20px;
      // transform: translateY(-5px);
    }

    &.launch {
      margin-bottom: 17px;
      margin-left: -8px;
      margin-top: -10px;
    }

    &.join {
      margin-top: 10px;
      margin-bottom: 2px;
      transform: translateX(-10px) rotate(2deg) scale(.9);
    }
  }

  .title {
    margin-bottom: 5px;
    margin-top: 20px;
  }
}

.hero.bottom-signup {
  .hero-body .notification {
    border-radius: 12px;

    .logo {
      width: 240px;
      margin-top: 20px;
    }
  }
}

.logo-container {
  text-align: center;

  .logo {
    width: 300px;
    margin: 20px auto 0px;
    text-align: center;
  }
}

.content-preview {

  .preview {
    display: flex;
    box-shadow: 1px 4px 12px -3px rgba(0, 0, 0, .15);
    margin-bottom: 20px;
    background-color: rgba(255, 255, 255, .3);
  }

  .maintext {
    font-size: 1em;
    font-weight: 600;
  }

  .subtext {
    font-size: .9em;
    opacity: .8;
  }

  .text {
    position: relative;
    display: block;
    padding: 20px;
  }

  .order {
    font-size: 1.4em;
    float: left;
    display: flex;
    min-width: 70px;
    justify-content: center;
    align-items: center;
    background-color: rgba(70, 70, 100, .08);
    margin-right: 10px;
  }
}

.slide-overview.subtitle {
  margin-bottom: 15px;
  font-weight: bold;
  opacity: .9;
}

.slide-summary {
  display: flex;
  flex-wrap: wrap;

  .icon {
    margin-right: 8px;
  }

  .type {
    padding: 8px 15px;
    margin: 0 10px 10px 0;
    background-color: rgba(70, 70, 100, .08);
    border-radius: 2px;
    max-width: 340px;
  }
}

.text-icon {
  font-size: 2em;
  font-family: sans-serif;
  font-weight: bold;
  height: 1.2em;
  letter-spacing: -1px;
  width: 100%;
  text-align: center;
  line-height: 1em;
  margin: 0 auto;
  padding: 0;
}

.hero.is-slide {
  // user-select: none;
  border-radius: 0px;

  .isModerator .image.fit-cover {
    max-height: 5em;
  }
}

.meta.level {
  justify-content: start;
  margin-left: 5px;
  align-items: center;
  margin-top: -1em;
}

.level.meta.vertical {
  margin-top: -.25em;
  margin-left: 0em;
  margin-bottom: 1.5em;
  color: #444;
  gap: .4em;
  flex-direction: column;
  align-items: flex-start;

  .square {
    display: flex;
    font-size: 1em;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    p {
      margin-left: .4em;
      flex-grow: 1;
    }

    .streamline {
      height: 1em;
      width: 1em;

      .a {
        stroke: currentColor;
      }
    }
  }
}

.square.big-box {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 1em;
  text-align: center;
  justify-content: center;
  align-items: center;
  border: 2px solid currentColor;
  border-radius: 6px;
  background-color: transparent;
  box-shadow: none;
  margin-bottom: 5px;
  height: 6em;

  &.is-small {
    font-size: .75em;
    border-width: 1px;

    .streamline {
      width: 1.5em;
      height: 1.5em;
    }
  }

  &:not(:last-of-type) {
    margin-right: 10px;
  }

  .streamline {
    width: 2em;
    height: 2em;
    margin: 0 auto;
  }
}

.tag-group {
  margin: 0px 0 1em;
  opacity: .8;
}

.tag.is-outlined {
  background: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 4px;
}
.tag {
  // background-color: var(--text);
  // color: var(--primary);
  padding: 0 1em;
  // font-weight: bold;
  // opacity: .7;
}

.description {
  margin-top: -10px;
  margin-bottom: 20px;
}

@media screen and (min-width: 1040px) {
  .recap-container {
    max-width: 1000px;
  }

  .page-frame {
    .container {
      // width: 80vw;
      max-width: 1040px;
    }
  }
}

@media screen and (max-width: 1040px) {
  .recap-container {
    max-width: calc(100% - 40px);
  }

  .page-frame .slide-preview-container {
    height: 50vw;
  }

  .page-frame {
    .container {
      // width: 80vw;
      max-width: 1040px;
    }
  }
}

@media screen and (max-width: 1000px) {
  .player-feedback {
    max-width: 100%;
    min-width: 100%;
  }

  .page-frame {
    .inline-slide-preview {
      transform: scale(.85);
    }
  }

  .page-frame .slide-preview-container {
    height: 55vw;
  }

  .page-frame .container {
    // width: 90vw;
    max-width: 950px;

    .button.register {
      width: 80%;
      margin: 30px 10% 10px;
    }
  }
}

@media screen and (max-width: 800px) {
  .page-frame {
    .inline-slide-preview {
      transform: scale(.8);
    }

    .order {
      min-width: 30px;
    }
  }

  .page-frame .recap-container {
    padding-left: 18px;

    .toc-column {
      display: none;
    }
  }

  .page-frame .slide-preview-container {
    height: 65vw;
  }
}

@media screen and (max-width: 720px) {
  .page-frame {
    .inline-slide-preview {
      transform: scale(.75);
    }
  }
}

@media screen and (max-width: 680px) {
  .page-frame {
    .inline-slide-preview {
      transform: scale(.65);
    }
  }
}

@media screen and (max-width: 600px) {
  .page-frame {
    .inline-slide-preview {
      transform: scale(.55);
    }
  }
}

@media screen and (max-width: 540px) {
  .page-frame {
    .inline-slide-preview {
      transform: scale(.45);
    }
  }
}

.container.deck-container {
  background-color: transparent;
  padding: 0em;
  border-radius: 10px;
  overflow: hidden;
  border: 0px;
  margin-bottom: 1.5em;
  margin-top: -.5em;
  box-shadow: 1px 5px 10px -4px rgba(0, 0, 0, .18);

}

.container {
  background-color: #fff;
  // color: var(--text);
  padding: 2em;
  border-radius: 6px;
  // box-shadow: 1px 8px 24px -12px rgba(123, 136, 168, .3);
  border: 1px solid var(--med-blue);
  box-shadow: 1px 5px 10px -4px rgba(0, 0, 0, .08);
  width: 100%;
  max-width: 900px;
  position: relative;

  &.is-transparent {
    background-color: transparent;
    box-shadow: none;
  }

  &.no-padding {
    padding: 0;
  }
}

.container.is-shell {
  padding: 0;
  border: 0px;
  background: transparent;

  .notification {
    border-radius: 10px;
    margin-bottom: 30px;
    margin-top: 50px;
    padding: 3em;
  }
}

.container.social-container {
  background-color: white;
  padding: 18px;
  border: 0px;
  margin: 20px auto 30px;
}

.recap-container.is-title {
  // display: none;
  background-color: transparent;
  margin-bottom: 20px;
  margin-top: -10px;
  box-shadow: none;
}

.recap-container.horizontal {
  flex-direction: column-reverse;

  .slide-toc {
    max-width: none;
    width: auto;
    height: 300px;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;

    .toc-item {
      display: inline-block;
      width: 200px;
      height: 100%;
    }
  }
}

.built-on {
  position: absolute;
  top: 1em;
  display: flex;
  align-items: center;
  margin: 0;
  font-size: .9em;
  opacity: 1;
  width: 100%;
  justify-content: center;
  z-index: 2;

  img {
    position: relative;
    opacity: 1;
    width: 144px;
    margin-left: 6px;
  }
}

.page-frame {
  background-color: white; // var(--accent);
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  padding-top: 1em;
  overflow-y: scroll;
  // font-family: var(--paraFont);

  // .title {
  //   color: var(--text);
  //   font-family: var(--titleFont)
  // }

  // .subtitle {
  //   color: var(--text);
  // }

}

.button {

  &.big-cta {
    // background-color: transparent;
    // background-color: var(--primary);
    // box-shadow: 1px 2px 12px -9px var(--text);
    // color: var(--text);
    border: none;
    font-weight: 400;
    font-size: 1.4rem;

    &.is-light-white {
      background-color: #eee;
    }
  }
}

.single-deck-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.slide-preview-container {
  margin: 0.7em auto 18px;
  height: 50vw;
  max-height: 489px;
  max-height: 400px;
  position: relative;
  user-select: none;
  background-color: white;
  border: none;
  border-radius: 12px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  .inner-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 7px;
    background-color: white;
    overflow: hidden;
  }

  .hero.is-slide {
    border-radius: 0px;
    overflow: hidden;
    box-shadow: 0px 10px 30px -12px var(--primary);
  }
}

.recap-container {
  margin: 0 auto;
  padding: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  // padding: 18px;
  // border-radius: 12px;
  overflow: hidden;
  // border: 1px solid var(--med-blue);
  // box-shadow: 1px 5px 18px -8px rgba(0, 0, 0, .1);
}

.toc-column {
  padding: 0 5px 0px 0px;
  margin-right: 20px;
  border-right: 1px solid var(--med-blue);
  background-color: #f8fdff;
  background-color: #f9fafd;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.toc-title {
  border-bottom: 1px solid #e3e8ee95;
  text-align: center;
  margin: 0 -5px 0 0px;
  padding: 10px;
  box-shadow: 1px 2px 10px -6px rgba(0, 0, 0, .15);
  font-size: .7em;
  text-transform: uppercase;
  font-weight: 500;
  color: #8e9eb1;
  // background-color: white;
}

.recap-title {
  // display: none;
  border-bottom: 1px solid #e3e8ee95;
  text-align: center;
  margin: 0 -18px 0 -20px;
  padding: 10px;
  // box-shadow: 1px 2px 10px -6px rgba(0,0,0,.15);
  font-size: .7em;
  text-transform: uppercase;
  font-weight: 500;
  color: #8e9eb1;
  // background-color: white;
}

.slide-toc {
  padding-top: 15px;
  height: calc(50vw + 100px);
  max-height: 595px; // with buttons below
  max-height: 545px; // without buttons below
  width: 196px;
  padding-right: 8px;

  &.pretty-scroll {
    overflow-y: scroll;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      width: 4px;
      margin: 20px 0px;
    }

    &::-webkit-scrollbar-thumb {
      width: 4px;
      border-radius: 4px;
      background-color: #8c9caa50;
    }
  }

  .toc-item {
    line-height: 1em;
    font-size: .8em;
    display: flex;
    align-items: center;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding-left: 9px;

    &.is-active {
      background-color: rgba(194, 227, 249, .65);
    }

    .desc {
      padding: 10px 10px 12px 10px;
      margin: 5px 8px 5px 0px;
      background-color: #fff;
      border-radius: 6px;
      cursor: pointer;
      box-shadow: 1px 2px 6px -2.75px rgba(131, 148, 158, .6);
      flex-grow: 2;
      // background-color: #625f5d;
      // color: white;

      .type {
        text-transform: uppercase;
        font-size: .75em;
        letter-spacing: .2px;
        color: #777;
      }

      .text {
        font-weight: 500;
        color: #222233;
      }

      .active-steps {
        margin: 15px 6px 5px 6px;
        // box-shadow: 1px 2px 5px rgba(0, 0, 0, .1);
        border-radius: 12px;
        border: 1px solid #eee;
        overflow: hidden;

        p {
          display: block;
          padding: 8px 5px;
          text-align: center;
          margin: 0px;
          // border-radius: 12px;

          &:not(:last-child) {
            border-bottom: 1px solid #eee;
          }

          &.is-active {
            background-color: #f8f8f8;
            color: #222;
            text-decoration: none;
            // text-decoration-style: dotted;
            text-decoration-color: #00adff;
            text-decoration-thickness: 2px;
          }
        }
      }
    }
  }

  .slide-num {
    font-weight: bold;
    margin-right: 6px;
    color: #8c9099;
    min-width: 19px;
    margin-top: -10px;
    text-align: center;
  }
}

.and-more.preview {
  display: block;
  background-color: #f8f8f8;
  // border-radius: 12px;
  padding: .75em;
  text-align: center;
  margin-bottom: 20px;
}

.form-inputs {
  max-width: 400px;
  margin: auto;

  .control {
    margin-top: 15px;
  }
}

.content-preview {

  .slide-type {
    text-transform: uppercase;
    font-size: .8em;
    opacity: .8;
    margin-left: 1.25em;
    margin-top: .75em;
    margin-bottom: -.5em;
  }

  .active-steps {
    margin: 15px 6px 5px 6px;
    // box-shadow: 1px 2px 5px rgba(0, 0, 0, .1);
    border-radius: 12px;
    border: 1px solid #eee;
    overflow: hidden;

    p {
      display: block;
      padding: 8px 5px;
      text-align: center;
      margin: 0px;
      cursor: pointer;
      // border-radius: 12px;

      &:not(:last-child) {
        border-bottom: 1px solid #eee;
      }

      &.is-active {
        cursor: default;
        background-color: #f8f8f8;
        color: #222;
        text-decoration: none;
        // text-decoration-style: dotted;
        text-decoration-color: #00adff;
        text-decoration-thickness: 2px;
      }
    }
  }
}
</style>
